import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5af6e891"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Fechar")
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "col-12 text-center banner_inicial" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Voltar")
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Fechar")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.svg" })
], -1))
const _hoisted_11 = { class: "user-name" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Olá, ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Faça suas compras agora ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-white-rounded" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "svg-icon-white",
    src: "/assets/icon/sacola_menu.svg"
  })
], -1))
const _hoisted_16 = { class: "ion-text-center bold" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Meus Pedidos", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lista de Compras", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ofertas"),
  /*#__PURE__*/_createTextVNode(" da "),
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/icon/ofertas_menu.svg" })
], -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode()
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "semana", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-white-rounded" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "svg-icon-white",
    src: "/assets/icon/desconto_menu.svg"
  })
], -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" DESCONTOS ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ATIVADOS", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic-descontos-texto" }, "VÁLIDO APENAS PARA LOJA FÍSICA", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" CONTEÚDOS/")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" TABLOIDES ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Churrascômetro", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carrinho de Compras", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Conta Digital", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "svg-icon-white-new",
  src: "/assets/icon/barcode.svg"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Leitor de Códigos", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_Campanha = _resolveComponent("Campanha")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_FooterMenu = _resolveComponent("FooterMenu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.isOpen
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "dark",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeBanner(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconFechar }, null, 8, ["icon"]),
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-end bg-top-menu" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        innerHTML: _ctx.push_banner.text
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.push_banner.image
                }, null, 8, _hoisted_4)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.campanhas.iframe.show
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.campanhas.iframe.show=false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconVoltar }, null, 8, ["icon"]),
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("iframe", {
            name: "frame",
            src: _ctx.campanhas.iframe.url,
            frameborder: "0",
            style: {"overflow":"hidden","height":"100%","width":"100%"},
            height: "100%",
            width: "100%",
            webkitallowfullscreen: "",
            mozallowfullscreen: "",
            allowfullscreen: ""
          }, null, 8, _hoisted_6)
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.campanhas.show
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.campanhas.show=false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconFechar }, null, 8, ["icon"]),
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Campanha, {
            campanhas: _ctx.campanhas,
            campanha: _ctx.campanhas.selecionada
          }, null, 8, ["campanhas", "campanha"])
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { class: "bg_background" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-end bg-top-menu" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMenu())),
                        size: "large",
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            color: "jauservelayoutalter",
                            slot: "icon-only",
                            icon: _ctx.icon_menu
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigate('/suporte'))),
                        size: "large",
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            color: "jauservelayoutalter",
                            slot: "icon-only",
                            icon: _ctx.icon_message
                          }, null, 8, ["icon"]),
                          (_ctx.total_notificacoes > 0)
                            ? (_openBlock(), _createBlock(_component_ion_badge, {
                                key: 0,
                                class: "badge-round",
                                slot: "start",
                                color: _ctx.total_notificacoes > 0 ? 'danger':'primary'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.total_notificacoes), 1)
                                ]),
                                _: 1
                              }, 8, ["color"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "1" }),
                  _createVNode(_component_ion_col, { size: "9" }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "2" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("span", null, _toDisplayString(_ctx.user_info.first_name), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "12",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigate('/mercado'))),
                        class: "icone-menu ic-8"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "6" }, {
                                default: _withCtx(() => [
                                  _hoisted_13,
                                  _hoisted_14
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, { size: "6" }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.pedido.show)
                    ? (_openBlock(), _createBlock(_component_ion_col, {
                        key: 0,
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigate('/pedidos'))),
                            class: "ion-align-items-center bg-ultimo-pedido"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "8" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_col, {
                                        class: "txt-previsao-ultimo-pedido",
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Previsão de " + _toDisplayString(_ctx.pedido.shipments[0].shipping_method.name.toLowerCase()=="receba em casa" ? 'entrega' : "retirada"), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, {
                                        class: "txt-janela-ultimo-pedido",
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.toDiaMes(_ctx.pedido.c_windowStartTime)) + ", " + _toDisplayString(_ctx.toHora(_ctx.pedido.c_windowStartTime)) + " - " + _toDisplayString(_ctx.toHora(_ctx.pedido.c_windowEndTime)), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, {
                                        class: "txt-previsao-ultimo-pedido",
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_16, "PEDIDO " + _toDisplayString(_ctx.pedido.order_no), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "txt-icon-ultimo-pedido",
                                size: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    class: "icon-ultimo-pedido",
                                    src: '/assets/icon/'+ (_ctx.pedido.shipments[0].shipping_method.name.toLowerCase() == 'receba em casa' ? 'entrega' : 'retirada' ) + '.svg'
                                  }, null, 8, _hoisted_17),
                                  _hoisted_18,
                                  _createTextVNode(" " + _toDisplayString(_ctx.pedido.shipments[0].shipping_method.name), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_col, {
                    class: _normalizeClass(_ctx.campanhas.campanhas.promocional.length > 1 ?'bg-top-header':''),
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.campanhas.campanhas.promocional.length > 1)
                        ? (_openBlock(), _createBlock(_component_swiper, {
                            key: 0,
                            slidesPerView: 'auto',
                            spaceBetween: 5,
                            centeredSlides: true,
                            direction: 'vertical',
                            autoplay: { delay: 6500, disableOnInteraction: false },
                            modules: _ctx.modules
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campanhas.campanhas.promocional, (campanha, index) => {
                                return (_openBlock(), _createBlock(_component_swiper_slide, {
                                  onClick: ($event: any) => (_ctx.showCampanha(campanha)),
                                  class: "swiper-slide-vertical",
                                  key: 'camp'+index
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_col, { size: "12" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(campanha.nome), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (campanha.urlparticipacao != '')
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "button-vermais",
                                          href: campanha.urlparticipacao
                                        }, " clique e participe ", 8, _hoisted_19))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modules"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigate('/pedidos'))),
                        class: "icone-menu ic-4"
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "ion-icon-white",
                          slot: "center",
                          icon: _ctx.icon_order
                        }, null, 8, ["icon"]),
                        _hoisted_20
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navigate('/listas'))),
                        class: "icone-menu ic-6"
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "ion-icon-white",
                          slot: "center",
                          icon: _ctx.icon_menu
                        }, null, 8, ["icon"]),
                        _hoisted_21
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "12",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.navigate('/dasemana'))),
                        class: "icone-menu ic-ofertas"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                size: "10",
                                class: "ic-ofertas-texto"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_22,
                                  _hoisted_23,
                                  _hoisted_24,
                                  _hoisted_25,
                                  _hoisted_26
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, { size: "2" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "12",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.navigate('/promocoes'))),
                        class: "icone-menu"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "4" }, {
                                default: _withCtx(() => [
                                  _hoisted_27
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                size: "8",
                                class: "ic-descontos"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_28,
                                  _hoisted_29,
                                  _hoisted_30
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "12",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.navigate('/tabloides'))),
                        class: "icone-menu ic-conteudos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.iconTab }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                size: "8",
                                class: "ic-conteudos"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_31,
                                  _hoisted_32,
                                  _hoisted_33
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.navigate('/churrasco'))),
                        class: "icone-menu ic-8a"
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "ion-icon-white",
                          slot: "center",
                          icon: _ctx.icon_churras
                        }, null, 8, ["icon"]),
                        _hoisted_34
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.navigate('/carrinho'))),
                        class: "icone-menu ic-4"
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "ion-icon-white",
                          slot: "center",
                          icon: _ctx.icon_cart
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_badge, {
                          class: "cartqtd",
                          color: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.cartItemNumber), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_35
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.navigate('/contadigital'))),
                        class: "icone-menu ic-4"
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "ion-icon-white",
                          slot: "center",
                          icon: _ctx.icon_home
                        }, null, 8, ["icon"]),
                        _hoisted_36
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.navigate('/gondola'))),
                        class: "icone-menu ic-8"
                      }, _hoisted_39)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _hoisted_40,
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      _hoisted_44
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FooterMenu, { data: {inicial:true} })
    ]),
    _: 1
  }))
}